export default __webpack_public_path__ + "static/media/NeerajSingh.c900f42f.jpg";